import request from '@utils/request'
import gateway from '@enum/gateway'

export const getBrandList = params =>
  request.fetch(gateway.essentialService + '/v1/api/brand/list', params)

export const deleteBrand = id =>
  request.delete(gateway.essentialService + '/v1/api/brand/' + id)

export const updateBrand = params => {
  let formData = new FormData()
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const element = params[key]
      formData.append(key, element)
    }
  }
  return request.ajax(
    'put',
    gateway.essentialService + '/v1/api/brand',
    formData,
    {
      'Content-type': 'multipart/form-data;'
    }
  )
}

export const createBrand = params => {
  let formData = new FormData()
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const element = params[key]
      formData.append(key, element)
    }
  }
  return request.ajax(
    'post',
    gateway.essentialService + '/v1/api/brand',
    formData,
    {
      'Content-type': 'multipart/form-data;'
    }
  )
}

export const bindChannelToBrand = brandDTO => {
  return request.put(gateway.essentialService + '/v1/api/brand/channels', {
    brandDTO
  })
}

export const setDefaultBrand = (id, isDefault = true) => {
  const url = isDefault
    ? '/v1/api/brand/default/'
    : '/v1/api/brand/default/cancel/'

  return request.put(gateway.essentialService + url + id)
}

export const getBrand = id =>
  request.fetch(gateway.essentialService + '/v1/api/brand/' + id)
